import React, { 
  //useState, 
  //useEffect 
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectPodcastSubmit, addPodcastFollows, } from '../podcastSubmitSlice'
//import { selectDashboard, postUpdateRssUrl, } from '../../dashboard/dashboardSlice'

import {
  Button,
  Card,
  //Form,
  //Message,
  //Checkbox,
} from 'semantic-ui-react';

export default function PodcastSubmit(props) {

  //const fromView = props.fromView;
  const dispatch = useDispatch()
  const { podcastFollows } = useSelector(selectPodcastSubmit);

  const handle_addPodcastFollows = () => {
    //console.debug('handle_addPodcastFollows');
    dispatch(addPodcastFollows());
  }

  return (
    <>
      <div className={'view-submit'}>
        <Card.Header>Save Your Selections</Card.Header>
        <Card.Description style={{margin: '25px 0', }}>
          <p>Review your imported Podcasts and save them to your iHeartRadio Podcast Following library.</p>
        </Card.Description>
        {/* <Card.Header>Terms &amp; Conditions</Card.Header> */}
        <Card.Description style={{margin: '10px 0 0 0', }}>
          <Button primary fluid
            loading={podcastFollows.loading}
            disabled={podcastFollows.loading || podcastFollows.error !== null || podcastFollows.totalFollows === 0}
            onClick={()=>{handle_addPodcastFollows()}}
            style={{marginTop: '25px', }}
          >
            Follow Selected Podcasts
          </Button>
        </Card.Description>
      </div>
    </>
  )
}